<button
  type="button"
  class="settings-item"
  [class.settings-item--last]="isLast()"
  (click)="pressed.emit()"
>
  <div class="settings-item__content">
    <div
      class="settings-item__icon"
      [class.settings-item__icon--destructive]="isDestructive()"
    >
      <ion-icon [name]="iconName()"></ion-icon>
    </div>
    <div class="settings-item__text">
      <span
        class="settings-item__title"
        [class.settings-item__title--destructive]="isDestructive()"
      >
        {{ title() }}
      </span>
      @if (subtitle()) {
        <span class="settings-item__subtitle">{{ subtitle() }}</span>
      }
    </div>
  </div>
  @if (showChevron() && !isDestructive()) {
    <ion-icon name="chevron-forward" class="settings-item__chevron"></ion-icon>
  }
</button>
